module.exports = __webpack_public_path__ + "img/congo.7d09076c.svg";